import React, { useEffect } from 'react';
import sample from 'lodash/sample';
import { useResponsive } from '/imports/core/api/responsiveContext';
import { Experiment as MarvelExperiment, Variant as MarvelVariant, emitter } from '@marvelapp/react-ab-test';
import intlHook from 'imports/core/api/useIntl';

export const LOCALE_TO_TEST = ['en', 'es', 'tr'];
const VARIANTS = ['control', 'var_1', 'var_3', 'var_4', 'var_7'];

const HomepageMobileABTest = (props) => {
  const { isStrictMobile } = useResponsive();
  const { locale } = intlHook();
  if (!LOCALE_TO_TEST.includes(locale) || !isStrictMobile) return props.children;

  useEffect(() => {
    if (!VARIANTS.includes(emitter.getActiveVariant('exp_homepage_mobile'))) {
      emitter.setActiveVariant('exp_homepage_mobile', sample(VARIANTS));
    }
  }, []);

  emitter.defineVariants('exp_homepage_mobile', VARIANTS);
  return (
    <MarvelExperiment name="exp_homepage_mobile">
      <MarvelVariant name="control">{props.children}</MarvelVariant>
      <MarvelVariant name="var_1">{props.children}</MarvelVariant>
      <MarvelVariant name="var_3">{props.children}</MarvelVariant>
      <MarvelVariant name="var_4">{props.children}</MarvelVariant>
      <MarvelVariant name="var_7">{props.children}</MarvelVariant>
    </MarvelExperiment>
  );
};

export default HomepageMobileABTest;
